import Vue from 'vue'
import $ga from '@/plugins/ga'

class APIError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

let $http = Vue.prototype.$http;

let api = {
  checkUsernameFree(name) {
    return $http.get("/api/user/register/username?name=" + encodeURIComponent(name), {_custom: {suppressNotifications: true}});
  },
  getRegistrationForm() {
    return $http.get("/api/registration/form");
  },
  resendVerificationEMail(email) {
    return $http.post("/api/user/verification/resendEmail", {email: email});
  },
  requestPasswordResetEMail(email) {
    return $http.post("/api/user/password/email", {
      email: email
    })
  },
  resetPassword(email, token, password, password_confirmation) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'User',
      eventAction: 'passwordReset'
    });
    return $http.post("/api/user/password/reset", {
      email: email,
      token: token,
      password: password,
      password_confirmation: password_confirmation,
    })
  },
  getProfile() {
    return $http.get("/api/user");
  },
  patchProfile(data) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'User',
      eventAction: 'updateProfile'
    });
    return $http.patch("/api/user", data);
  },
  subscribeNewsletter(){
    return $http.post("/api/user/newsletter/subscribe")
  },
  putUsername(username) {
    let data = {username: username}
    return $http.put("/api/user/username", data);
  },
  getUsername() {
    return $http.get("/api/user/username");
  },
  deleteMyAccount() {
    return $http.post("/api/user/delete", { confirmed: true })
  },
  loadAllUserInformation() {
    return $http.get("/api/user/all");
  },
  getSubscriptionUrl(plan) {
    return $http.get("/api/user/subscription/" + encodeURIComponent(plan) + '/url');
  },
  cancelSubscription(data) {
    return $http.post("/api/user/subscription/cancel", data);
  },
  getSubscriptionInfo() {
    return $http.get("/api/user/subscription");
  },
  getSubscriptions() {
    return $http.get("/api/subscriptions");
  },
  activatePremiumCouponCode(code) {
    return $http.post("/api/subscriptions/coupon", {code: code});
  },
  getAction(actionStr) {
    return $http.get("/api/action/" + encodeURIComponent(actionStr));
  },
  performAction(actionStr) {
    return $http.post("/api/action", {action: actionStr});
  },
  addUserPlatform(data) {
    return $http.post("/api/user/platform", data);
  },
  deleteUserPlatform(code, data) {
    return $http.delete("/api/user/platform/" + encodeURIComponent(code), {data: data});
  },
  getUsersAdminPortals() {
    return $http.get("/api/user/admin/portals");
  },
  getFriends() {
    return $http.get("/api/friend/list");
  },
  requestFriendship(userUid) {
    return $http.post("/api/friend/request", { user_uid: userUid })
  },
  decideFriendship(userUid, accept) {
    return $http.post("/api/friend/decide", { accept: accept, user_uid: userUid })
  },
  removeFriendship(userUid) {
    return $http.delete("/api/friends/" + encodeURIComponent(userUid))
  },
  getLeagueTable(gameuid) {
    return $http.get("/api/gamemode/liga/" + encodeURIComponent(gameuid) + "/table");
  },
  getGameInstances(states) {
    return $http.get("/api/user/games", {
      params: {
        state: states
      }
    });
  },
  getGameInstanceInformation(gameuid) {
    return $http.get("/api/gameinstance/" + encodeURIComponent(gameuid));
  },
  getGameParticipants(gameuid) {
    return $http.get("/api/gameinstance/" + encodeURIComponent(gameuid) + '/participants');
  },
  getGameInvitablePlayers(gameuid) {
    return $http.get("/api/gameinstance/" + encodeURIComponent(gameuid) + '/invitablePlayers');
  },
  startGame(gameuid) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'start'
    });
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + '/start');
  },
  sendCheckinReminder(gameuid){
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + '/checkin/remind');
  },
  startGameCheckIn(gameuid) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'startCheckIn'
    });
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + '/checkin/start');
  },
  performGameCheckIn(gameuid) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'checkIn'
    });
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + '/checkin/perform');
  },
  finishGame(gameuid) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'finish'
    });
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + '/finish');
  },
  startNextRound(gameuid) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'nextRound'
    });
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + '/startNextRound');
  },
  checkGameCreation(gameType) {
    return $http.post("/api/gameinstances/creationCheck", {
      gameType: gameType
    });
  },
  deleteGame(gameuid) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'delete'
    });
    return $http.delete("/api/gameinstance/" + encodeURIComponent(gameuid));
  },
  deleteGameInvitation(gameuid) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'deleteInvitation'
    });
    return $http.delete("/api/gameinstance/" + encodeURIComponent(gameuid) + "/invitation");
  },
  joinGameinstance(gameuid) {
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + '/join');
  },
  loadGames() {
    return $http.get("/api/game");
  },
  getGameOptions(game) {
    if (!game) {
      throw new Error('game not specified!')
    }
    return $http.get("/api/game/"+ encodeURIComponent(game) + "/options");
  },
  loadPlatforms() {
    return $http.get("/api/platform");
  },
  createGameInstance(type, data) {
    $ga.send({
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'create.' + type
    });
    let gameModeUrlPart = this.getGameModeUrlPart(type)
    if (gameModeUrlPart) {
      return $http.post("/api/gamemode/" + encodeURIComponent(gameModeUrlPart), data)
    } else {
      return new Promise((resolve, reject) => {
        reject(new APIError(`Unbekannter Wettkampftyp ${type}`));
      });
    }
  },
  calculateGameInstanceCreation(type, data) {
    let gameModeUrlPart = this.getGameModeUrlPart(type)
    if (gameModeUrlPart) {
      return $http.put("/api/gamemode/" + encodeURIComponent(gameModeUrlPart), data)
    } else {
      return new Promise((resolve, reject) => {
        reject(new APIError(`Unbekannter Wettkampftyp`));
      });
    }
  },
  getGameModeUrlPart(type) {
    if (type == 'league.classic') {
      return 'liga'
    } else if (type == 'ko.classic') {
      return 'ko'
    } else if (type == 'groupphase_with_ko') {
      return 'groupphase_with_ko'
    }
    else if (type == 'ko.mixed') {
      return 'ko_mixed'
    }
  },
  loadClubs(){
    return $http.get("/api/clubs");
  },
  loadLigaGameSchedules(gameuid) {
    return $http.get("/api/gamemode/liga/" + encodeURIComponent(gameuid) + "/gameschedules");
  },
  loadKOGameSchedules(gameuid) {
    return $http.get("/api/gamemode/ko/" + encodeURIComponent(gameuid) + "/gameschedules");
  },
  loadKoMixedGameSchedules(gameuid) {
    return $http.get("/api/gamemode/ko_mixed/" + encodeURIComponent(gameuid) + "/gameschedules");
  },
  addFriendsToGameInstance(gameuid, userUIDs) {
    let data = {
      usersToAdd: userUIDs
    };
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + "/addPlayers", data);
  },
  inviteUsersToGameInstance(gameuid, userUIDs) {
    let data = {
      userUIDs: userUIDs
    };
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + "/invitePlayers", data);
  },
  inviteSpectatorsToGameInstance(gameuid, userUIDs) {
    let data = {
      userUIDs: userUIDs
    };
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + "/inviteSpectators", data);
  },
  patchGameInstanceParticipant(gameuid, userUID, data) {
    return $http.patch("/api/gameinstance/" + encodeURIComponent(gameuid) + "/participants/" + encodeURIComponent(userUID), data);
  },
  addMixedGaminstanceSingleResult(gameinstance, data) {
    return $http.post("/api/gamemode/ko_mixed/" + encodeURIComponent(gameinstance.uid) + "/result/single", data);
  },
  addGameInstanceSoccerResult(gameinstance, data) {
    if (gameinstance.type == 'league.classic') {
      return this.addLeagueResult(gameinstance.uid, data);
    } else if (gameinstance.type == 'ko.classic') {
      return this.addKOGameResult(gameinstance.uid, data);
    } else if (gameinstance.type == 'ko.mixed') {
      return this.addKOMixedGameResult(gameinstance.uid, data); }
      else {
      return new Promise((resolve, reject) => {
        reject(new APIError(`Unbekannter Wettkampftyp`));
      });
    }
  },
  resetGameInstanceSoccerResult(gameinstance, data) {
    if (gameinstance.type == 'league.classic') {
      return this.resetResult('liga', gameinstance.uid, data);
    } else if (gameinstance.type == 'ko.classic') {
      return this.resetResult('ko', gameinstance.uid, data);
    } else if (gameinstance.type == 'ko.mixed') {
      return this.resetResult('ko_mixed', gameinstance.uid, data);
    } else {
      return new Promise((resolve, reject) => {
        reject(new APIError(`Unbekannter Wettkampftyp`));
      });
    }
  },
  resetResult(type, gameuid, data) {
    return $http.post("/api/gamemode/" + encodeURIComponent(type) + "/" + encodeURIComponent(gameuid) + "/result/reset", data);
  },
  initChatForMatch(gameuid, matchuid, data){
    return $http.post(`/api/gameinstance/${encodeURIComponent(gameuid)}/match/${encodeURIComponent(matchuid)}/create-chat`, data)
  },
  addNomination(gameuid, data){
    return $http.post(`/api/gamemode/liga/${encodeURIComponent(gameuid)}/nominate-user`, data)
  },
  addDates(gameuid, data){
    return $http.post(`/api/gamemode/liga/${encodeURIComponent(gameuid)}/add-dates`, data)
  },
  addLeagueResult(gameuid, data) {
    return $http.post("/api/gamemode/liga/" + encodeURIComponent(gameuid) + "/result", data);
  },
  addKOGameResult(gameuid, data) {
    return $http.post("/api/gamemode/ko/" + encodeURIComponent(gameuid) + "/result", data);
  },
  addKOMixedGameResult(gameuid, data) {
    return $http.post("/api/gamemode/ko_mixed/" + encodeURIComponent(gameuid) + "/result", data);
  },
  dropPlayer(gameuid, userUID) {
    return $http.delete("/api/gameinstance/" + encodeURIComponent(gameuid) + "/participants/" + encodeURIComponent(userUID))
  },
  getUsersProfile(uid) {
    return $http.get("/api/users/" + encodeURIComponent(uid));
  },
  getEnv() {
    return $http.get("/api/public/env");
  },
  getPublicAll() {
    return $http.get("/api/public/all");
  },
  sendChatMessage(name, message) {
    let data = {
      message: message
    }
    return $http.post("/api/chat/" + encodeURIComponent(name), data);
  },
  getChatConversations(name) {
    return $http.get("/api/chat/" + encodeURIComponent(name));
  },
  getPlacesAutocomplete(v) {
    return $http.get("/api/places/autocomplete", {params: {input: v}});
  },
  uploadUserAvatar(formData) {
    let headers = {'Content-Type': 'multipart/form-data' };
    return $http.post("/api/user/image", formData, {headers: headers});
  },
  claimPushToken(platform, token) {
    return $http.post("/api/user/notification/claimPushToken", {
      platform: platform,
      token: token
    });
  },
  getEvidenceImages(gameuid, matchUid) {
    return $http.get("/api/gameinstance/" + encodeURIComponent(gameuid) + "/match/" + encodeURIComponent(matchUid) + "/evidenceImages");
  },
  uploadEvidenceImage(gameuid, matchUid, formData) {
    let headers = {'Content-Type': 'multipart/form-data' };
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + "/match/" + encodeURIComponent(matchUid) + "/evidenceImages", formData, {headers: headers});
  },
  deleteEvidenceImage(gameuid, matchUid, imgUid) {
    return $http.delete("/api/gameinstance/" + encodeURIComponent(gameuid) + "/match/" + encodeURIComponent(matchUid) + "/evidenceImages/" + encodeURIComponent(imgUid));
  },
  confirmMatchResult(gameuid, matchUid) {
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + "/match/" + encodeURIComponent(matchUid) + "/confirmResult");
  },
  preparePurchaseProduct(sku, data) {
    return $http.post("/api/product/" + encodeURIComponent(sku) + "/purchase", data);
  },
  getPremiumProducts() {
    return $http.get("/api/products/premium");
  },
  getCoinProducts() {
    return $http.get("/api/products/coins");
  },
  getCoinAccount() {
    return $http.get("/api/user/coinAccount");
  },
  getUserCoinTransactions() {
    return $http.get("/api/user/coinAccount/transactions");
  },
  getShopProducts() {
    return $http.get("/api/shop/products");
  },
  purchaseShopProduct(sku) {
    return $http.post("/api/shop/product/" + encodeURIComponent(sku) + "/purchase");
  },
  getPublicGames() {
    return $http.get("api/gameinstances/public");
  },
  getPublicUsercups() {
    return $http.get("api/gameinstances/usercups");
  },
  getPublicGameInfo(gameuid) {
    return $http.get("api/gameinstances/public/" + encodeURIComponent(gameuid));
  },
  createVeto(matchUid, data) {
    return $http.post("/api/match/" + encodeURIComponent(matchUid) + "/veto", data);
  },
  getCountries() {
    return $http.get("api/countries");
  },
  authenticateAgainstWebGuard() {
    return new Promise((resolve, reject) => {
      $http.get("/auth/web/tokenAuth")
        .then(res => {
          resolve(res);
        })
        .catch((err) => {
          console.log('Webauth failed', err)
          reject(err);
        });
    })
  },
  getProfileViaWebGuard() {
    return $http.get("/auth/web/info", {withCredentials: true})
  },
  logoutFromWebGuard() {
    return new Promise((resolve, reject) => {
      $http.get("/auth/web/logout")
        .then(res => {
          resolve(res);
        })
        .catch((err) => {
          console.log('Logout failed', err)
          reject(err);
        });
    })
  },
  disconnectFromExternalAccount(driver) {
    return $http.delete("/api/user/externalAccount/" + encodeURIComponent(driver));
  },
  getBankAccounts() {
    return $http.get("/api/user/bankAccounts")
  },
  storeBankAccount(data) {
    return $http.post("/api/user/bankAccounts", data)
  },
  deleteBankAccount(bankAccountUid) {
    return $http.delete("/api/user/bankAccount/" + encodeURIComponent(bankAccountUid))
  },
  coinPayoutToBankAccount(bankAccountUid, data) {
    return $http.post("/api/user/bankAccount/" + encodeURIComponent(bankAccountUid) + "/payout", data)
  },
  calculateCoinPayoutToBankAccount(bankAccountUid, data) {
    return $http.post("/api/user/bankAccount/" + encodeURIComponent(bankAccountUid) + "/calculatePayout", data, {_custom: {suppressNotifications: true}})
  },
  getGameInstanceTeams(uid) {
    return $http.get("/api/gameinstance/" + encodeURIComponent(uid) + "/team/list")
  },

  createGameInstanceTeam(uid, data) {
    return $http.post("/api/gameinstance/" + encodeURIComponent(uid) + "/team", data)
  },
  inviteUsersToGameInstanceTeam(gameuid, teamUid, userUIDs) {
    let data = {
      userUIDs: userUIDs
    };
    return $http.post("/api/gameinstance/" + encodeURIComponent(gameuid) + "/team/" + encodeURIComponent(teamUid) + "/invite", data);
  },
  acceptTeamInvitation(gameuid, teamUid, data = {}){
    return $http.post(`/api/gameinstance/${encodeURIComponent(gameuid)}/team/${teamUid}/accept-invitation`, data)
  },
  dropUserFromGameInstanceTeam(gameuid, teamUid, userUid) {
    if (!userUid) {
      throw new Error('userUid missing')
    }
    return $http.delete("/api/gameinstance/" + encodeURIComponent(gameuid) + "/team/" + encodeURIComponent(teamUid) + "/members/" + encodeURIComponent(userUid));
  }
}

api.APIError = APIError
Vue.prototype.$api = api

export default api
